// src/lib/inviteCode.js
// Shared by the setup step and the Dashboard "Find your Paul" card.
// Accepts a pasted invite link, a whole shared message, or a bare prayer code.
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/lib/firebase';

const INVITE_KEY = 'sheepheard:pendingInvite';

export function parseInviteInput(text) {
  const s = String(text || '').trim();
  if (!s) return null;
  const m = s.match(/\/join\/([A-Za-z0-9-]{8,32})/);
  const code = (m ? m[1] : s).toUpperCase().replace(/[^A-Z0-9]/g, '');
  return code.length >= 8 && code.length <= 32 ? code : null;
}

/** Looks the code up. Throws an Error with a user-readable message when it cannot be used. */
export async function resolveInviteInput(text, myUid) {
  const code = parseInviteInput(text);
  if (!code) throw new Error('Paste the invite link or code your Paul sent you.');
  let snap;
  try {
    snap = await getDoc(doc(db, 'prayerCodes', code));
  } catch {
    throw new Error('Could not check that code. Check your connection and try again.');
  }
  if (!snap.exists()) throw new Error('That link or code was not found. Ask your Paul for a new one.');
  const data = snap.data();
  if (data.uid === myUid) throw new Error('That is your own code.');
  return { code, name: String(data.name || 'Friend').slice(0, 60) };
}

/** Stores the code for useInviteLink (mounted in Layout) to complete the link. */
export function queueInvite(code) {
  try {
    localStorage.setItem(INVITE_KEY, code);
    window.dispatchEvent(new Event('sheepheard:invite'));
  } catch { /* storage unavailable */ }
}